<template>
  <div class="kpt-software-root kpt-single-page">
    <vue-headful title="Software" />
    <div class="hero is-primary is-bold">
      <div class="hero-body">
        <div class="kpt-docu-search">
          <h2 class="title">Software</h2>
          <h5 class="subtitle">Download software pertaining to your Kymeta hardware.</h5>
        </div>
      </div>
    </div>
    <br>
    <div class="container">
      <div class="kpt-software-topics mt-3 pl-5 pr-5">
        <router-view :key="$route.fullPath"></router-view>
      </div>
    </div>
  </div>
</template>
<script>
import { getCurrentInstance } from 'vue';
import { pinToDashMixin } from '../shared/mixins/pinToDash';

export default {
  mixins: [pinToDashMixin],
  setup() {
    const app = getCurrentInstance();
    const root = app.proxy.$root;
    // eslint-disable-next-line no-unused-expressions
    (async () => {
      await root.$store.dispatch('fetchStorageFiles', 'software-downloads');
    })();
  }
}
</script>
<style lang="scss" scoped>
@import '../styles/_colors';

.kpt-software-root {
  min-height: 100%;
  background-color: $white-bis;

  .hero-pin-bar {
    margin-top: -32px;
    text-align: right;
  }

  .kpt-software-content {
    padding: 12px;
    height: calc(100% - 50px);
    overflow-y: auto;
  }

  .kpt-docu-search {
    display: flex;
    flex-direction: column;
    align-items: center;

    .field {
      width: 35rem;
    }
  }

  .kpt-document-search {
    height: 100%;
  }
}
</style>
